/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result for Codex hook events
 */
export type CodexHookResult = {
  /**
   * Permission decision for blocking events: allow or deny
   */
  decision?: string | undefined;
  /**
   * Reason for the decision, shown to the user
   */
  reason?: string | undefined;
};

/** @internal */
export const CodexHookResult$inboundSchema: z.ZodMiniType<
  CodexHookResult,
  unknown
> = z.object({
  decision: z.optional(z.string()),
  reason: z.optional(z.string()),
});

export function codexHookResultFromJSON(
  jsonString: string,
): SafeParseResult<CodexHookResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CodexHookResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CodexHookResult' from JSON`,
  );
}
